import styled from 'styled-components';

export const GaleriaWrapper = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(51, 51, 51, 0.85);
  z-index: 10000;
  top: 40px;
  width: 100%;
  height: calc(100% - 40px);
`;

export const CloseGaleria = styled.button`
  position: absolute;
  right: 10px;
  top: 0;
  background-color: transparent;
  border: none;
`;

export const Slider = styled.div`
  margin: 20px 80px;

  @media screen and (max-width: 768px) {
    margin: 0px 10px;
  }
`;

export const ImageWrapper = styled.div`
  max-width: 100vw;
  max-height: calc(100vh - 80px);
  height: auto;
`;

export const Image = styled.img`
  max-width: 100vw;
  max-height: calc(100vh - 80px);

  object-fit: contain;
`;

export const BackButton = styled.div`
  position: absolute;
  top: 50%;
  left: 50px;
  cursor: pointer;
`;
export const ForwardButton = styled.div`
  position: absolute;
  top: 50%;
  right: 50px;
  cursor: pointer;
`;
